import {
  AppBar,
  Badge,
  Box,
  CircularProgress,
  IconButton,
  Stack,
  Toolbar,
  Tooltip,
  Typography,
  alpha,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import RefreshIcon from "@mui/icons-material/Refresh";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { useColorMode } from "../../contexts/ColorModeContext";

const MODULO_LABEL = {
  rh: "Recursos Humanos",
  ssma: "SSMA",
  qualidade: "Qualidade",
};

const HomeV2Header = ({
  modulo,
  onMenuClick,
  count,
  onRefresh,
  onFilter,
  refreshing = false,
  filtersActive = 0,
}) => {
  const { mode } = useColorMode();
  const title = MODULO_LABEL[modulo] || String(modulo || "").toUpperCase();

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={(theme) => ({
        width: "100%",
        bgcolor:
          mode === "dark"
            ? alpha(theme.palette.background.paper, 0.94)
            : alpha("#FFFFFF", 0.92),
        color: "text.primary",
        borderBottom: `1px solid ${theme.palette.divider}`,
        backdropFilter: "blur(8px)",
      })}
    >
      <Toolbar sx={{ gap: 1, minHeight: 58, px: { xs: 1.5, md: 2.5 } }}>
        {onMenuClick && (
          <IconButton
            color="primary"
            edge="start"
            aria-label="Abrir menu"
            onClick={onMenuClick}
            sx={{ display: { md: "none" }, mr: 0.25 }}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography variant="subtitle1" fontWeight={700} noWrap>
            Home · {title}
          </Typography>
          <Typography variant="caption" color="text.secondary" noWrap>
            Preview V2
            {typeof count === "number" ? ` · ${count} colaboradores` : ""}
          </Typography>
        </Box>

        <Tooltip title="Esta é uma versão de análise">
          <Box
            sx={{
              display: { xs: "none", sm: "inline-flex" },
              px: 1.25,
              py: 0.4,
              borderRadius: 999,
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: 0.4,
              textTransform: "uppercase",
              color: "#C4890F",
              bgcolor: alpha("#E8A317", 0.16),
              border: `1px solid ${alpha("#E8A317", 0.35)}`,
              mr: 0.5,
            }}
          >
            Preview
          </Box>
        </Tooltip>

        <Stack direction="row" spacing={0.5} alignItems="center">
          <Tooltip title={onRefresh ? "Atualizar" : "Atualizar indisponível"}>
            <span>
              <IconButton
                color="primary"
                size="small"
                aria-label="Atualizar"
                disabled={!onRefresh || refreshing}
                onClick={() => onRefresh?.()}
              >
                {refreshing ? (
                  <CircularProgress size={16} color="inherit" />
                ) : (
                  <RefreshIcon fontSize="small" />
                )}
              </IconButton>
            </span>
          </Tooltip>

          <Tooltip title={onFilter ? "Gerenciar filtros" : "Filtros indisponíveis"}>
            <span>
              <IconButton
                color="primary"
                size="small"
                aria-label="Filtros"
                disabled={!onFilter}
                onClick={() => onFilter?.()}
              >
                <Badge
                  color="secondary"
                  badgeContent={filtersActive || null}
                  max={9}
                  overlap="circular"
                >
                  <FilterAltOutlinedIcon fontSize="small" />
                </Badge>
              </IconButton>
            </span>
          </Tooltip>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default HomeV2Header;
